import styled from 'styled-components';

export const StyledUserPanelPermissions = styled.div`
    width: 100%;
    height: 100%;

    @media only screen and (max-width: 926px) {
        margin-top: 20px;

        > h2 {
            font-size: 30px;
        }
    }
`;

export const StyledUserPanelPermissionsComponent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    @media only screen and (max-width: 926px) {
        > h2 {
            padding-top: 20px;
            font-size: 30px;
        }
    }
`;

export const StyledPermissionsRowElement = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: space-between;

    > div {
        &:first-child {
            width: ${({ $minusWidth }) =>
                $minusWidth ? `calc(100% - ${$minusWidth}px)` : 'calc(100% - 104px)'};
            overflow-x: scroll;

            scrollbar-color: transparent transparent;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                height: 6px;
            }

            &::-webkit-scrollbar-track {
                background: transparent;
            }

            &::-webkit-scrollbar-thumb {
                background: transparent;
            }
        }
    }
`;

export const StyledDataPermissionWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    border-radius: 25px 9px 9px 25px;
    border: 4px solid #6786be;
`;
